import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import {
    ProductsItemType,
    BaseCurrencyUnits,
    CartItemsTotals,
    CartItemsShippingAddress,
} from 'common/types';

export type CartItemBody = {
    productCode: string,
    quantity: number
};

export interface CartItemResponse extends CartItemsShippingAddress {
    tokenValue: string,
    type: string,
    channel: string,
    currency: string,
    locale: string,
    checkoutState: string,
    totals: CartItemsTotals,
    items: Array<{
        quantity: number,
        product: ProductsItemType,
        total: BaseCurrencyUnits,
    }>,
}

class CartItemsRepository extends BaseRepositoryClass implements RepositoryType {
    save(token: string, item: CartItemBody) {
        return this
            .requester
            .post<CartItemResponse>(`grant/cart/${token}/items`, item);
    }
}

export default CartItemsRepository;
